import { DateTime } from 'luxon';

export const calculateAge = (birthDate: Date, referenceDate: Date): number => {
    const birth = DateTime.utc(birthDate.getFullYear(), birthDate.getMonth() + 1, birthDate.getDate()).startOf('day');

    const reference = DateTime.utc(referenceDate.getFullYear(), referenceDate.getMonth() + 1, referenceDate.getDate()).startOf(
        'day'
    );

    const age = reference.diff(birth, 'years').years;

    return age;
};
